import { Deployment, DeploymentStatus } from '@back4app2/sdk';

// Still building, or about to: its log may simply not have lines yet.
const BUILDING = new Set<string>([
  DeploymentStatus.INITIALIZING,
  DeploymentStatus.INITIALIZED,
  DeploymentStatus.QUEUED,
  DeploymentStatus.DEPLOYING,
  DeploymentStatus.CANCELING,
]);

/**
 * Done building, whatever the outcome: everything it was going to log, it
 * logged. A finished deployment with no log lines had them deleted — the build
 * logs of older deployments are not kept.
 */
export const hasFinishedBuilding = (deployment: Deployment): boolean =>
  !BUILDING.has(deployment.status) || deployment.deployTask?.finishedAt instanceof Date;
